export const dataReducer = (state = {}, action) => {
  switch (action.type) {
    case 'REVERSE_BATCHES': {
      const { batches } = state

      return {
        ...state,
        batches: batches.reverse()
      }
    }
    case 'UPDATE_BATCH': {
      const { batches } = state
      const { item, position } = action.data
      batches[position] = item

      return {
        ...state,
        batches
      }
    }
    case 'UPDATE_LOGIC_DATA': {
      const { logicData } = state
      const path = action.data.id.split('.')
      if (1 < path.length) {
        if (null === action.data.logicData) {
          delete logicData.items[path[0]]
        } else {
          logicData.items[path[0]] ||= {}
          logicData.items[path[0]][path[1]] = action.data.logicData
        }
      } else {
        logicData[path[0]] = action.data.logicData
      }

      return {
        ...state,
        logicData
      }
    }
    case 'UPDATE_ERRORS': {
      const { errors } = state
      const id = action.data.id || 'pattern'
      const index = errors.indexOf(id)
      0 <= index && errors.splice(index, 1)
      true == action.data.error && errors.push(id)

      return {
        ...state,
        errors
      }
    }
    case 'RESET': {
      return {
        ...state,
        ...action.data
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
